import getStore from '../store/store';
import { userDate, addYears, startOfDay } from 'owa-datetime';

/** Gets the selected TO date, or default to 2 years into the future */
export default () => getStore().toDate || addYears(startOfDay(userDate()), 2);
